export const logWarning = (msg: string, context?: Record<string, any>) => {
  console.warn(msg, context);
};

export const logError = (msg: string, context?: Record<string, any>) => {
  console.error(msg, context);
};
